$(document).ready(function () {

  // product accordion
  
  $('.accordion .item .toggle').click(function() {
    $(this).parent().toggleClass('active');
  });

  // faq accordion
  
  $('.accordion-faqs .item .toggle').click(function() {
    $(this).parent().toggleClass('active');
  });

});